import { Control } from "./control";

export class Label extends Control {
    public text: string = "";

    public getComponentName(): string {
        return "LabelComponent";
    }
}
